import { EnumValues } from '@/services/types/EnumValues';

/**
 * Why UnableToDeleteModal is showing instead of the delete confirm dialog - see
 * openDeleteDialog/confirmDelete in useScheduledPaymentAction. Title/body/button copy differs by
 * reason (and by payment kind - see ScheduledPaymentModal/BatchOverviewModal, which each render
 * their own copy for the same reason value).
 */
export const UnableToDeleteReasonEnum = {
  // Checked client-side, at the moment Delete is clicked - the current NZ time falls within the
  // daily send window (see isWithinDeleteBlockWindow), so the bank may be actively sending this
  // payment right now.
  WITHIN_BLOCK_WINDOW: 'within_block_window',
  // Batch-only: the group delete endpoint itself 400/409'd with BatchDeletionErrorCodeEnum - the
  // group's state changed server-side (e.g. force-completed, or picked up by processing) despite
  // passing the client-side window check above (see confirmDelete in useScheduledPaymentAction).
  DELETE_CONFLICT: 'delete_conflict'
} as const;
export type TUnableToDeleteReason = EnumValues<typeof UnableToDeleteReasonEnum>;
